import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {SignedInContextService} from "@app/@shells/signed-in-shell/signed-in-context.service";
import {CheckedComponentInternal} from "@app/campaigns/campaign/@common/campaign-drafting/checked-component-internal";
import {FormGroup} from "@angular/forms";
import { ConfigService } from '@app/@core/@config/config.service';

@Component({
  selector: 'app-campaign-phone-number[campaignForm]',
  templateUrl: './campaign-phone-number.component.html',
  styleUrls: ['./campaign-phone-number.component.scss']
})
export class CampaignPhoneNumberComponent implements OnInit {
  @Input() campaignForm!: FormGroup;

  constructor(public configService: ConfigService) { }

  ngOnInit(): void {
  }
}
